// assets/reusely-tradein.js

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('reusely-tradein-app');
  if (!root) return;

  const API_BASE = 'https://api.reusely.com/api/v3/public';

  // ⬇️ Put your REAL key + tenant here
  const REUSELY_HEADERS = {
    accept: 'application/json',
    'content-type': 'application/json',
    'x-api-key': 'N92CUjiqrziIOFu0lLvJp1gIIYkbaAMRBYcTsgDl8inTN4KLNhjws4j4neyfAuE9',
    'x-tenant-id': 'ef3d572076cd0353097caef57897df39435543cc16f1b21b1903347d035c5a8e',
  };

  // --- STEP 0: Retrieve Account ---
  async function fetchAccount() {
    const res = await fetch(`${API_BASE}/account`, {
      headers: REUSELY_HEADERS,
    });

    if (!res.ok) throw new Error('Failed to load Reusely account');
    return res.json();
  }

  // --- STEP 1a: List Categories ---
  async function fetchCategories(limitDevice) {
    const url = new URL(`${API_BASE}/catalog/category`);
    if (limitDevice) {
      // e.g. "mail-in" / "in-store"
      url.searchParams.set('limit_device', limitDevice);
    }

    const res = await fetch(url, {
      headers: REUSELY_HEADERS,
    });
    if (!res.ok) throw new Error('Failed to load categories');

    const data = await res.json();
    console.log('Reusely categories raw response:', data);

    const categories =
      (data.result && data.result.data) ||
      data.data ||
      [];

    return categories;
  }

  // --- STEP 1b: List devices under a category (v3: /catalog/category-brand/{slug})
  async function fetchDevices(slugCategory) {
    const res = await fetch(
      `${API_BASE}/catalog/category-brand/${slugCategory}`,
      {
        headers: REUSELY_HEADERS,
      }
    );

    if (!res.ok) throw new Error('Failed to load devices');

    const data = await res.json();
    console.log('Reusely devices raw response:', data);

    const devices =
      (data.result && data.result.data) ||
      data.data ||
      [];

    return devices;
  }

  // --- STEP 2: List models for a brand + device ---
  async function fetchModels(slugBrand, slugDevice) {
    const res = await fetch(
      `${API_BASE}/catalog/model-device/${slugBrand}/${slugDevice}`,
      {
        headers: REUSELY_HEADERS,
      }
    );
    if (!res.ok) throw new Error('Failed to load models');

    const data = await res.json();
    console.log('Reusely models raw response:', data);

    const models =
      (data.result && data.result.data) ||
      data.data ||
      [];

    return models;
  }

  // --- STEP 3: Fetch condition questions for a model ---
  async function fetchConditions(modelId) {
  const res = await fetch(
    `${API_BASE}/catalog/model-condition/${modelId}`,
    {
      headers: REUSELY_HEADERS,
    }
  );

  if (res.status === 404) {
    console.warn('model-condition route not found; using simple offer fallback.');
    return []; // no questions, we’ll just use the "upto" value
  }

  if (!res.ok) throw new Error('Failed to load conditions');

  const data = await res.json();
  console.log('Reusely conditions raw response:', data);

  return (data.result && data.result.data) || data.data || [];
}

  // --- STEP 5: Fetch offer / trade-in value for a model ---
  async function fetchOffer(modelId, answers) {
    const res = await fetch(
      `${API_BASE}/catalog/model-offer/${modelId}`,
      {
        method: 'POST',
        headers: REUSELY_HEADERS,
        body: JSON.stringify({ answers }),
      }
    );

    if (!res.ok) throw new Error('Failed to get offer');

    const data = await res.json();
    console.log('Reusely offer raw response:', data);

    return data.result || data.data || data;
  }

  function renderError(message) {
    root.innerHTML = `<p style="color:red">${message}</p>`;
  }

  // --- INIT ---
  async function init() {
    try {
      root.innerHTML = '<p>Loading trade-in options…</p>';

      const account = await fetchAccount();
      console.log('Reusely account:', account);

      const categories = await fetchCategories();
      renderCategoryStep(categories);
    } catch (err) {
      console.error(err);
      renderError('Sorry, we could not load trade-in options right now.');
    }
  }

  // --- RENDER STEP 1: Categories ---
  function renderCategoryStep(categories) {
    root.innerHTML = `
      <div class="reusely-step">
        <h2>Select what you want to trade in</h2>
        <div class="reusely-grid reusely-grid--categories">
          ${categories
            .map(
              (cat) => `
            <button class="reusely-chip reusely-category"
                    data-slug="${cat.slug}">
              ${cat.image_url ? `<img src="${cat.image_url}" alt="${cat.name}" />` : ''}
              <span>${cat.name}</span>
            </button>
          `
            )
            .join('')}
        </div>
        <div id="reusely-devices"></div>
      </div>
    `;

    const devicesRoot = document.getElementById('reusely-devices');

    root.querySelectorAll('.reusely-category').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const slugCategory = btn.dataset.slug;
        devicesRoot.innerHTML = '<p>Loading devices…</p>';

        try {
          const devices = await fetchDevices(slugCategory);
          renderDeviceStep(devicesRoot, devices);
        } catch (err) {
          console.error(err);
          devicesRoot.innerHTML =
            '<p style="color:red">Failed to load devices.</p>';
        }
      });
    });
  }

  // --- RENDER STEP 2: Devices ---
  function renderDeviceStep(container, devices) {
    container.innerHTML = `
      <div class="reusely-step">
        <h2>Select your device</h2>
        <div class="reusely-grid reusely-grid--devices">
          ${devices
            .map((device) => {
              const brandSlug =
                device.brand_slug ||
                (device.brand && device.brand.slug) ||
                device.brand;
              const deviceSlug = device.slug;
              const img = device.image || device.image_url;

              return `
                <button class="reusely-card reusely-device"
                        data-slug-brand="${brandSlug}"
                        data-slug-device="${deviceSlug}">
                  ${img ? `<img src="${img}" alt="${device.name}" />` : ''}
                  <span>${device.name}</span>
                </button>
              `;
            })
            .join('')}
        </div>
        <div id="reusely-models"></div>
      </div>
    `;

    const modelsRoot = document.getElementById('reusely-models');

    container.querySelectorAll('.reusely-device').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const slugBrand = btn.dataset.slugBrand;
        const slugDevice = btn.dataset.slugDevice;
        modelsRoot.innerHTML = '<p>Loading models…</p>';

        try {
          const models = await fetchModels(slugBrand, slugDevice);
          renderModelStep(modelsRoot, models);
        } catch (err) {
          console.error(err);
          modelsRoot.innerHTML =
            '<p style="color:red">Failed to load models.</p>';
        }
      });
    });
  }

  // --- RENDER STEP 3: Models ---
  function renderModelStep(container, models) {
    container.innerHTML = `
      <div class="reusely-step">
        <h2>Select your exact model</h2>
        <div class="reusely-grid reusely-grid--models">
          ${models
  .map((model) => {
    const modelId = model.model_id || model.id;
    const upto = model.upto || ''; // comes from your model JSON
    return `
      <button class="reusely-chip reusely-model"
              data-model-id="${modelId}"
              data-model-upto="${upto}">
        <span>${model.name}</span>
      </button>
    `;
  })
  .join('')}

        </div>
        <div id="reusely-next-step"></div>
      </div>
    `;

    const nextRoot = document.getElementById('reusely-next-step');

    container.querySelectorAll('.reusely-model').forEach((btn) => {
  btn.addEventListener('click', async () => {
    const modelId = btn.dataset.modelId;
    const upto = btn.dataset.modelUpto;
    nextRoot.innerHTML = '<p>Loading…</p>';

    try {
      const questions = await fetchConditions(modelId);

      if (!questions || questions.length === 0) {
        // No questions available → just show simple offer using "upto"
        renderSimpleOffer(nextRoot, upto, modelId);
      } else {
        // Questions exist → use full condition flow
        renderConditionStep(nextRoot, questions, modelId);
      }
    } catch (err) {
      console.error(err);
      // On any error, fall back to simple offer instead of red error text
      renderSimpleOffer(nextRoot, upto, modelId);
    }
  });
});
  }

  function renderSimpleOffer(container, upto, modelId) {
  container.innerHTML = `
    <div class="reusely-step">
      <h2>Your Trade-In Value</h2>
      ${
        upto
          ? `<p class="offer-amount">Up to $${upto}</p>`
          : `<p>We couldn't fetch an online estimate. Please contact us for a quote.</p>`
      }
      <p class="reusely-note">
        Final value will be confirmed after we inspect your device in store.
      </p>
    </div>
  `;
}


  // --- RENDER STEP 4: Conditions + Offer ---
  function renderConditionStep(container, questions, modelId) {
    container.innerHTML = `
      <div class="reusely-step">
        <h2>Answer a few questions</h2>
        <form id="reusely-condition-form">
          ${questions
            .map(
              (q) => `
            <div class="reusely-condition">
              <h3>${q.question}</h3>
              ${q.answers
                .map(
                  (a) => `
                <label>
                  <input type="radio"
                         name="q_${q.id}"
                         value="${a.value}" />
                  ${a.label}
                </label>
              `
                )
                .join('')}
            </div>
          `
            )
            .join('')}
          <button type="submit" class="reusely-button">
            Get My Trade-In Value
          </button>
        </form>
        <div id="reusely-offer"></div>
      </div>
    `;

    const form = document.getElementById('reusely-condition-form');
    const offerRoot = document.getElementById('reusely-offer');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      offerRoot.innerHTML = '<p>Calculating…</p>';

      const formData = new FormData(form);
      const answers = {};

      formData.forEach((value, key) => {
        answers[key.replace('q_', '')] = value;
      });

      try {
        const offer = await fetchOffer(modelId, answers);
        const amount = offer.amount || offer.value || offer.offer_value;

        offerRoot.innerHTML = `
          <h2>Your Trade-In Value</h2>
          <p class="offer-amount">
            ${amount ? `$${amount}` : 'Offer available – value returned from API.'}
          </p>
        `;
      } catch (err) {
        console.error(err);
        offerRoot.innerHTML =
          "<p style='color:red'>Failed to calculate offer.</p>";
      }
    });
  }

  // Kick things off
  init();
});
